<template>
    <v-container>

        <v-row no-gutters class="mb-3">
            <v-col cols="6">
                <back-button/>
            </v-col>
            <v-col cols="6" align="right" v-if="showSaveBtn">
                <v-btn @click="showConfirm" color="primary" :class="['black--text', {'bottom-button': isMobile}]"
                       depressed large :disabled="disabled" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
                <component
                    :is="routeComponent"
                    @change="userData = $event"
                    @plan="showConfirm"
                    @coupon="couponId = $event"
                    style="margin-bottom: 50px"/>

                <div class="container-bottom-button" v-if="showSaveBtn"/>

            </v-col>
        </v-row>

        <kimsa-confirm
            ref="confirmModal"
            :title="$t('common.notice')"
            :content="confirmMessage"
            :loading="loading"
            :persistent="false"
            @confirm="save"
            :close-on-confirm="false"
        />

    </v-container>
</template>

<script>

import ProfessionalInfo from "@/components/company/ProfessionalInfo";
import SelectPlan from "@/components/company/SelectPlan";
import BasicInfo from "@/components/company/BasicInfo";

import firebase, {db} from '@/utils/Firebase'
import KimsaConfirm from "@/components/common/KimsaConfirm";
import {mapActions} from "vuex";
import BackButton from "@/components/common/BackButton";
import {loadStripe} from '@stripe/stripe-js';

export default {
    components: {
        BackButton,
        KimsaConfirm,
        ProfessionalInfo,
        SelectPlan,
        BasicInfo,
    },
    data() {
        return {
            userData: null,
            loading: false,
            confirmMessage: '',
            couponId: null,
        }
    },
    computed: {
        mode(vm = this) {
            return vm.$route?.params?.mode || null
        },
        disabled(vm = this) {
            if (vm.mode === 'SelectPlan')
                return (!vm.userData || (vm.userData && vm.userData.priceId === vm.currentSubscriptionId))

            if (vm.mode === 'BasicInfoStepper')
                return (!vm.userData || (vm.userData && (!vm.userData.phone || !vm.userData.name)))
            return false
        },
        currentSubscriptionId(vm = this) {
            return vm.account && vm.account.stripeAccount && vm.account.stripeAccount.currentSubscription && vm.account.stripeAccount.currentSubscription.priceId || null
        },
        isCurrentSubscriptionFree(vm = this) {
            return vm.userData?.isFree || false
        },
        paymentMethodId(vm = this) {
            return vm.account?.stripeAccount?.paymentMethod?.id || null
        },
        routeComponent(vm = this) {
            if (vm.account?.accountType === 'coach_company' && vm.mode === 'SelectPlan') return 'error'
            return vm.mode
        },
        showSaveBtn(vm = this) {
            return vm.mode !== 'SelectPlan'
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        showConfirm() {
            const vm = this

            if (vm.mode === 'SelectPlan') {

                if (!vm.isCurrentSubscriptionFree && !vm.paymentMethodId)
                    return vm.toast(vm.$t('payment.no_has_credit_card'), 'error')

                vm.confirmMessage = vm.$t('coach.confirm_plan')
                let isTrialEnded = vm.account?.stripeAccount?.trialEnded || false
                if (!isTrialEnded) vm.confirmMessage = `<b>${vm.$t('coach.yet_free_days')}</b> ${vm.confirmMessage}`
                vm.$refs.confirmModal.show()
            } else {
                vm.save()
            }
        },
        subscribePlanCoach: firebase.functions().httpsCallable('httpPayments-subscribePlanCoach'),
        updatePhoneStripe: firebase.functions().httpsCallable('httpPayments-updatePhoneStripe'),
        async save() {
            const vm = this
            vm.loading = true

            if (vm.mode === 'ProfessionalInfo') vm.userData.sport_areas = vm.userData.sport_areas.map(sport => sport.value)

            if (vm.mode === 'SelectPlan' && vm.userData) {
                await vm.setSubscriptionCoachPlan()
                vm.$refs.confirmModal.hide()
                await vm.bindUserAccount(vm.currentUser)
                vm.loading = false
                vm.$router.go(-1)
                return
            }

            if (vm.mode === 'BasicInfoStepper' && vm.userData) await vm.updatePhoneStripe()

            await db.collection('users').doc(vm.currentUser.uid).update(vm.userData)
            await vm.bindUserAccount(vm.currentUser)
            vm.loading = false
            vm.$router.go(-1)
        },
        async setSubscriptionCoachPlan() {
            const vm = this
            let subscribePayload = {
                planId: vm.userData.priceId,
                isFree: vm.userData.isFree === true,
                addTrial: true,
                couponId: vm.couponId,
            }
            await vm.subscribePlanCoach(subscribePayload).then(async result => {
                if (result.data.requiresAction) {
                    const clientSecret = result.data.paymentIntentClientSecret
                    const stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
                    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret);
                    if (error) {
                        console.log('Error en la autenticación 3D Secure:', error.message);
                        vm.toast(`${vm.$t('payment.subscription_failed')}: 3DS`, 'error')
                    } else {
                        if (paymentIntent.status === 'succeeded') {
                            console.log('Pago completado con éxito');
                        }
                    }
                }
            }).catch(err => {
                console.log(`${vm.$t('payment.subscription_failed')}: ${err.message}`)
            })
        }
    },
}
</script>

<style scoped>

.bottom-button {
    display: flex;
    position: fixed;
    bottom: 3%;
    left: 5%;
    width: 90%;
    padding: 5px;
    background-color: #FFFFFF;
    z-index: 6;
}

.container-bottom-button {
    margin-top: 60px;
    background-color: rgba(255, 255, 255, .9);
    height: 80px;
}

</style>